import styled, { css } from "styled-components";
import InputMask from "react-input-mask";

export const Container = styled.div`
  display: flex;
  min-width: 100%;
  max-width: 100%;
  flex-direction: column;

  fieldset,
  main {
    margin: 0;
    border: #fff 1px solid;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 0 0 0 0.5rem;
    height: 50px;
    font-size: var(--font-inscricao);
    border-radius: var(--medium-border-radius);
    z-index: 5;
    min-width: 100%;

    legend {
      display: flex;
      flex-direction: row;
      padding-left: 0.5rem;

      div {
        padding-left: 0.5rem;
      }
    }

    input {
      width: 100%;
      background: transparent;
      padding: 0.5rem;
      margin-top: -0.2rem;
      cursor: text;
      -webkit-tap-highlight-color: transparent;
      border: #eee;
      border-radius: var(--border-radius);
      border: #eee solid 1px;
      color: #111;

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        display: none;
        -webkit-appearance: none;
        margin: 0;
      }

      &::-webkit-outer-spin-button,
      &::-webkit-inner-spin-button {
        -webkit-appearance: none;
      }
      &[type="number"] {
        -moz-appearance: textfield;
      }
    }
  }

  ${(props) =>
    props.disabled &&
    css`
      opacity: 0.5;
    `}
`;

export const Message = styled.p`
  padding: 0.2rem 0 0 1rem;
  margin: 0;
  font-style: normal;
  font-weight: normal;
  font-size: var(--font-inscricao);
  line-height: 14px;
  min-height: 16px;
  color: var(--color-error);

  @media screen and (min-width: 900px) {
    min-height: 24px;
    font-size: 14px;
  }
`;

export const InputMaskInput = styled(InputMask)`
  padding: 0.2rem 0 0 1rem;
  margin: 0;
  font-style: normal;
  font-weight: normal;
  font-size: var(--font-inscricao);
  line-height: 14px;
  min-height: 16px;
  color: var(--color-error);

  @media screen and (min-width: 900px) {
    min-height: 24px;
    font-size: 14px;
  }
`;
